import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '@/lib/api';
import { LoadingShell } from '@/components/ui-bits';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function CompanyDetailPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/companies/${id}`).then((r) => setData(r.data)).catch((err) => toast.error(err?.response?.data?.detail || 'Error'));
  }, [id]);

  if (!data) return <LoadingShell />;
  const c = data.company;

  return (
    <div>
      <Link to="/app/companies" className="btn-ghost mb-3 inline-flex"><ArrowLeft className="h-4 w-4" /> Empresas</Link>
      <div className="surface p-5 mb-4">
        <h1 className="font-display text-2xl font-semibold">{c.name}</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {[c.industry, c.city, c.website, c.email, c.phone].filter(Boolean).join(' · ') || 'Sin detalles'}
        </p>
        {c.notes && <p className="text-sm mt-3 whitespace-pre-wrap">{c.notes}</p>}
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="surface p-5">
          <h2 className="font-display font-semibold mb-3">Leads ({(data.leads || []).length})</h2>
          {(data.leads || []).length === 0 && <p className="text-sm text-muted-foreground">Sin leads vinculados</p>}
          {(data.leads || []).map((l) => (
            <Link key={l.id} to={`/app/leads/${l.id}`} className="block py-2 border-b border-border/50 text-sm hover:bg-accent/40 px-1 rounded">
              {l.first_name} {l.last_name} · {l.email || l.phone_e164 || '—'}
            </Link>
          ))}
        </div>
        <div className="surface p-5">
          <h2 className="font-display font-semibold mb-3">Deals ({(data.deals || []).length})</h2>
          {(data.deals || []).length === 0 && <p className="text-sm text-muted-foreground">Sin deals</p>}
          {(data.deals || []).map((d) => (
            <Link key={d.id} to="/app/deals" className="block py-2 border-b border-border/50 text-sm hover:bg-accent/40 px-1 rounded">
              <span className="font-medium">{d.name}</span>
              <span className="text-muted-foreground"> · ${Number(d.amount || 0).toLocaleString('es-MX')} · {d.stage}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
